import React from 'react';
import {Provider} from 'react-redux';
import compose from 'recompose/compose';
import AdminLayout from '../components/admin/layout/index';
import withCheckAuth from './with-check-auth';
import withFetchLanguages from './with-fetch-languages';

import store from '../redux/store';

const enhance = compose(
	withCheckAuth,
	withFetchLanguages
);

export default function withAdminLayout(Component) {
	const EnhancedComponent = enhance(Component);

	return props => (
		<Provider store={store}>
			<AdminLayout {...props}>
				<EnhancedComponent {...props}/>
			</AdminLayout>
		</Provider>
	);
}



// WEBPACK FOOTER //
// ./src/client/routes/with-admin-layout.jsx